module.exports = __webpack_public_path__ + "img/img_b.7693de29.png";